// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.PasswordField = (function(){
  function PasswordField(cfg, index, form) {
    this._super.apply(this, arguments); // call generic TextField constructor
  }
  PasswordField.prototype = {
    _template: 
      '<div class="form-group">' +
        '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
        '<div class="col-sm-<%=helpText? "8" : "9"%>">' +
          '<input type="password" class="form-control" id="<%=id%>" name="<%=name%>" placeholder="<%=placeholder===false? \'\' : placeholder || label%>">' +
        '</div>' +
      '<% if (helpText) { %>' +
        '<div class="col-sm-1 hidden-xs">' +
          '<i class="fa fa-question-circle-o" role="button" data-toggle="popover" title="<%=helpText.title%>" data-content="<%=helpText.content%>"></i>'+
        '</div>' +
      '<% } %>' +
      '<% if (errorText) { %>' +
        '<div class="col-sm-9 col-sm-offset-3 error-text">' +
          '<p><%=errorText%></p>' +
        '</div>' +
      '<% } %>' +
      '</div>',

      regex: /^.{6,}$/
  };

  // inherit from generic field
  PD.forms.fields.register(["password", "PasswordField"], PasswordField, PD.forms.fields.TextField);

  return PasswordField;
})();
